import get from 'lodash/get';
import * as jwRelatedVideoActions from '../../action_creators/video/jw_related_video_action_creators';
import JwRelatedVideoModel from '../../../models/video/jw_related_video_model';
import notFoundActionCreator from '../../action_creators/not_found_status_action_creator';
import log from '../../../services/logger_service';

export default function fetchJwRelatedVideoDetail(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(jwRelatedVideoActions.jwRelatedVideoLoading({}, store));
    return JwRelatedVideoModel.fetch(params, store)
      .then(function handleJwRelatedVideoDetailData(JwRelatedVideoData) {
        dispatch(
          jwRelatedVideoActions.jwRelatedVideoLoaded(
            JwRelatedVideoData.data,
            store
          )
        );
      })
      .catch(function handleUserError(err) {
        const status = get(err, 'response.status') || 500;

        if (status === 404 || status === 401) {
          dispatch(notFoundActionCreator(404, 'NOT_FOUND_STATUS', store));
        }

        if (status === 500) {
          dispatch(notFoundActionCreator(500, 'ERROR_STATUS', store));
          log.error(
            err,
            `Error in jwRelatedVideo actions, message: ${err.message}`
          );
        }

        dispatch(jwRelatedVideoActions.jwRelatedVideoLoadError(err, store));
      });
  };
}
